export const forBusiness_creative_balance = [
	{
		icon: '☝️',
		title: 'balanceData_title1',
		subtitle: 'balanceData_subtitle1',
	},
	{
		icon: '🤘',
		title: 'balanceData_title2',
		subtitle: 'balanceData_subtitle2',
	},
	{
		icon: '🎯',
		title: 'balanceData_title3',
		subtitle: 'balanceData_subtitle3',
	},
	{
		icon: '🚀',
		title: 'balanceData_title4',
		subtitle: 'balanceData_subtitle4',
	},
];
